import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import GoogleAddressSearchBar from '../components/auto-complete-search-bar/GoogleAddressSearchBar'
import { Select } from '../../../global/components/select/Select'
import { tireCountData } from '../../../schedule/components/schedule-modal/components/choose-service/select-quantity/SelectQuantity'
import styles from './styles.module.css'
import PrimaryButton from '../../../global/components/buttons/primary-button/PrimaryButton'
import { ISchedulerStateProps } from '../../../schedule/components/schedule-modal/components/container-modal/initialData'
import { Address } from '../../../../../app/types/scheduling'
import { ICustomerInformationData } from '../../../schedule/components/schedule-modal/components/customer-information/CustomerInformation'
import { DeepPartial } from 'typeorm'
import { ITiresCombination } from '../../../../../app/entities/TiresCombination'

interface IAddressSearchWithTireQuantityProps {
  isZipCodeServiced: any
  setIsZipCodeServiced: Dispatch<SetStateAction<boolean | undefined>>
  displayAvailabilityCalendar: Function
  schedulerState: ISchedulerStateProps
  setSchedulerState: Dispatch<SetStateAction<ISchedulerStateProps>>
}
export default function AddressSearchWithTireQuant(
  props: IAddressSearchWithTireQuantityProps,
) {
  const {
    isZipCodeServiced,
    setIsZipCodeServiced,
    displayAvailabilityCalendar,
    schedulerState,
    setSchedulerState,
  } = props

  const [addressInput, setAddressInput] = useState<string>('')
  const [formattedAddress, setFormattedAddress] = useState<Address>(
    {} as Address,
  )

  const onChange = (e: { target: { value: number } }) => {
    const tiresCombination: DeepPartial<ITiresCombination> = {
      ...schedulerState.tiresCombination,
      frontCount: e.target.value,
      rearCount: 0,
    }
    setSchedulerState((prevState) => ({
      ...prevState,
      tiresCombination: tiresCombination,
    }))
    displayAvailabilityCalendar()
  }

  useEffect(() => {
    const customerInformation: ICustomerInformationData = {
      ...schedulerState.customerInformation,
      address: formattedAddress.address,
      city: formattedAddress.city,
      state: formattedAddress.state,
      zipCode: formattedAddress.zipCode,
    }
    setSchedulerState((prevState) => ({
      ...prevState,
      customerInformation: customerInformation,
    }))
  }, [formattedAddress])

  const buttonName =
    isZipCodeServiced === false ? 'Address Not Serviced' : 'View Appointments'

  return (
    <div className={styles.mainContainer}>
      <div>{`Enter an address below to see available TRMI appointments`}</div>
      <GoogleAddressSearchBar
        addressInput={addressInput}
        setAddressInput={setAddressInput}
        setIsZipCodeServiced={setIsZipCodeServiced}
        setFormattedAddress={setFormattedAddress}
      />
      <div className={styles.buttonContainer}>
        <Select
          name='frontCount'
          onChange={onChange}
          defaultValue={
            Number(schedulerState.tiresCombination?.frontCount) +
            Number(schedulerState.tiresCombination?.rearCount)
          }
          label='Quantity'
          width='156px'
          data={tireCountData}
        />
        <PrimaryButton
          buttonName={buttonName}
          onClick={() => displayAvailabilityCalendar()}
          disabled={!isZipCodeServiced}
        />
      </div>
    </div>
  )
}
